module.exports = __webpack_public_path__ + "img/vertical_6_4_9006.7949eede.png";